import styled from "styled-components";
import Globais from "../../css/Globais";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  position: relative; /* necessário p/ posicionar a imagem */
`;

export const ContainerTitulo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; /* se quiser empilhar textos/inputs */
`;

export const TituloForm = styled.h2`
  width: 10rem;
  text-align: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.8rem;
  width: 80%;
  @media (min-width: 900px) {
    font-size: 2.1rem;
  }
  @media (min-width: 1276px) {
    font-size: 2.5rem;
  }
`;
